<template>
  <div class="rt-content">
    <el-row :gutter="20">
      <el-col :span="16">
        <notice-bar></notice-bar>
      </el-col>
      <el-col :span="8">
        <my-info />
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="15">
        <!-- 收费信息 -->
        <rt-pay-table :isCollaps="isCollaps"/>
      </el-col>
      <el-col :span="9">
        <!-- 场内列表 -->
        <rt-car-table :height="rightHeight" />
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-col>
        <!-- 实时图像 -->
        <rt-video :height="rightHeight - 440"/>
      </el-col>
    </el-row>
    <!--
    <div class="rt-main">
      <el-row :gutter="10">
        <el-col :span="isCollaps ? 24 : 16" class="rt-main-position"  :style="{height: rightHeight + 'px'}">
          <leave-query-content v-if="showQueryTable" />
        </el-col>
        <el-col v-show="!isCollaps" :span="isCollaps ? 0 : 8" class="rt-main-position" :style="{height: rightHeight + 'px'}">
        </el-col>
      </el-row>
    </div>-->
    <!-- 出场订单 -->
    <el-drawer
      title="收费弹窗"
      size="20%"
      :visible.sync="showOrderInfo"
      :modal="false"
      @close="closeDrawer"
    >
      <div style="position: relative;">
        <el-image :src="require('@/assets/img/nodata02@2x.png')" alt="" style="width: 100%;"></el-image>
        <div class="drawBox">
          <pay-order-card :height="rightHeight - 228" />
        </div>
      </div>
    </el-drawer>
    <dialog-deduction-voucher :showdialog.sync="showDeductionVoucher" />
    <dialog-get-invoice :showdialog.sync="showGetInvoice" />
    <dialog-enter-time :showdialog.sync="showEnterTime" />
  </div>
</template>

<script>
//  支付表格
import rtPayTable from "@/serviceComponents/realtimePayTable";
// 实时出入视频 图片
import rtVideo from "@/serviceComponents/realtimeVideo";
// 场内车辆列表
import rtCarTable from "./components/realtimeCarTable";
// 离场支付订单
import payOrderCard from "./components/payOrderCard";
// 岗亭信息
import myInfo from "@/serviceComponents/myinfo";
//抵扣券  弹窗
import dialogDeductionVoucher from "@/serviceComponents/dialogDeductionVoucher";
//领取发票  弹窗
import dialogGetInvoice from "@/serviceComponents/dialogGetInvoice";
//没有匹配到车辆 输入时间补录  弹窗
import dialogEnterTime from "@/serviceComponents/dialogEnterTime";
// import leaveQueryContent from "@/serviceComponents/leaveQuery";
import noticeBar from "@/serviceComponents/noticeBar2";

import {
  blackParkInPubSub,
} from "@/service/pubsub/index";

export default {
  components: {
    rtPayTable,
    rtVideo,
    rtCarTable,
    myInfo,
    payOrderCard,
    dialogDeductionVoucher,
    dialogGetInvoice,
    dialogEnterTime,
    // leaveQueryContent,
    noticeBar,
  },
  data() {
    return {
      showDeductionVoucher: false,
      showGetInvoice: false,
      showEnterTime: false,
      rightHeight: 0,
    };
  },
  computed: {
    isCollaps: function () {
      return this.$store.state.layout.isCollaps;
    },
    showQueryTable: function () {
      return this.$store.state.order.showOrder || false;
    },
    showOrderInfo: function () {
      return this.$store.state.order.showOrderDetail || false;
    },
    direction:function(){
      return this.$route.params.Direction?this.$route.params.Direction:''
    },
  },
  mounted() {
    blackParkInPubSub.unsubscribe();
    blackParkInPubSub.subscribe(this.getBlackMsg);
    this.calcHeight();
    window.onresize = () => {
      this.calcHeight();
    };
  },
  methods: {
    showLeaveQuery() {
      this.$store.dispatch("GetShowOrderDetail", true);
    },
    calcHeight() {
      this.rightHeight = document.querySelectorAll('.layout-main')[0].offsetHeight - 40;
    },
    closeDrawer() {
      this.$store.dispatch("GetShowOrderDetail", false);
    },
    getBlackMsg(data) {
      if (data.message_type === '1' && data.ForeignFrom || data.message_type === '20'){
        const h = this.$createElement;
        this.$msgbox({
          title: '提示',
          message: h('div', null, [
            h('p', null, `车牌号：${data.plate_number}`),
            h('p', null, '黑名单，禁止入场'),
            h('p', null, `备注：${data.message_type === '20' ? data.cmd_msg : data.ForeignFrom}`)
          ]),
          confirmButtonText: '确定',
        })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.realtime-btn-list {
  text-align: left;
  margin-bottom: 20px;
}
  .rt-main-position{
    position: relative;
    & .realtime-video-list{
      position: absolute;
      left: 5px;
      bottom: 0;
      width: calc(100% - 10px);
    }
    & .my-info-content{
      position: absolute;
      bottom: 0;
      right: 5px;
      width: calc(100% - 10px);
      overflow-x: auto;
    }
    & .realtime-table-content,
    & .pay-order-content{
      height: calc(100% - 258px);
      background: #fff;
    }
  }
@media screen and (max-height: 800px){
  .realtime-table-content,
  .pay-order-content{
    height: 52vh!important;
  }
}
</style>

<style lang="scss">
  .drawBox{
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }
  .el-drawer__header{
    margin-bottom: 0;
  }
  .el-drawer__body{
    overflow-y: auto;
  }
  .rt-table-list{
    .el-table {
      th{
        /*padding: 0;*/
        background: rgba(94, 127, 236, 0.03);
        font-weight: bold;
        color: #000;
      }
      td{
        padding: 3px 0;
      }
    }
  }
</style>
